import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { leadQueryKeys } from "./leadQueryKeys";

export async function leadStatusListQueryFn({ api }: { api: ApiType }) {
  return (await api.leadApi.findStatus()).data;
}

export function useQueryLeadStatus({ api }: { api: ApiType }) {
  return useQuery({
    queryKey: leadQueryKeys.leadStatus({}),
    queryFn: () => leadStatusListQueryFn({ api }),
  });
}
